// ITBIS fijo de República Dominicana (18%). Refleja la regla del backend:
// el impuesto se aplica solo si el tenant tiene tax_enabled activo (por defecto
// lo está). Estas funciones son SOLO para vistas previas en pantalla; el total
// real de la orden siempre lo recalcula el backend al crearla o al pagarla.

export const ITBIS_RATE = 0.18;

// El toggle del superadmin ("Cálculo de Impuestos") vive en tenant.tax_enabled.
// Si no tenemos el tenant a mano, asumimos activo (igual que el backend).
export function isTaxEnabled(tenant) {
  return !(tenant && tenant.tax_enabled === false);
}

export function calcTax(subtotal, tenant) {
  const base = Number(subtotal) || 0;
  return isTaxEnabled(tenant) ? base * ITBIS_RATE : 0;
}

export function calcTotals(subtotal, tenant) {
  const base = Number(subtotal) || 0;
  const tax = calcTax(base, tenant);
  return { subtotal: base, tax, total: base + tax };
}

// Etiqueta dinámica para la fila de impuesto: "ITBIS (18%)".
export function itbisLabel() {
  return `ITBIS (${Math.round(ITBIS_RATE * 100)}%)`;
}
